
import { Table as BootstrapTable } from 'react-bootstrap';
import RadioInput from 'components/form/RadioInput';
import { getDataFromLocalStorage } from 'utils/helpers';
import React, { useEffect, useState } from 'react';
import CheckBox from 'components/form/CheckBox';
import Label from 'components/form/Label';
import { useSelector } from 'react-redux';

const EventPricing = ({ isNational, priceArray, isEdit, handelClick }) => {
    const userData = getDataFromLocalStorage();
    const { user_type, membership_plan_id } = userData;

    const { eventData, inrPrice } = useSelector((state) => ({
        eventData:
            user_type === '0' ? state.global.eventData : state.global.eventData,
        inrPrice: state.currency.inrPrice
    }));
    const [selectedIds, setSelectedIds] = useState([]);
    const [eventType, setEventType] = useState("");

    const {
        event_pricing = [],
        dashboard_pricing_selection = [],
        pricing_categories = [],
        event_mode,
        pricing_currency,
    } = eventData;

    const findCategory =
        user_type === '0'
            ? pricing_categories
            : dashboard_pricing_selection.find(
                (o) => `${o.id}` === `${membership_plan_id}`
            )?.data || [];

    const showEventPricing =
        findCategory.some((o) => o.is_checked) || user_type === '0';

    useEffect(() => {
        if (event_pricing.length > 0 && selectedIds.length === 0) {
            setSelectedIds([event_pricing[0].id]); // first category
        }
        if (event_mode && !eventType) {
            const firstMode = event_mode.split(",")[0]; // first mode
            setEventType(firstMode);
        }
    }, [event_pricing, event_mode]);


    const handleCheckboxChange = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id)
                ? prev.filter((item) => item !== id)
                : [...prev, id]
        );
    };

    const handleEventTypeChange = (e) => {
        setEventType(e.target.value);
    };

    const convertPrice = (price) => {
        let convertedPrice = parseFloat(price);
        if (isNaN(convertedPrice)) return 0;
        if (pricing_currency === "USD" && isNational) {
            // USD → INR
            convertedPrice = convertedPrice * inrPrice;
        } else if (pricing_currency === "INR" && !isNational) {
            // INR → USD
            convertedPrice = convertedPrice / inrPrice;
        }

        return Number(convertedPrice.toFixed(2));
    };


    const priceLabels = {
        oral: "Early Bird Price",
        poster: "Final Price",
        onSpot: "On Spot Price"
    };

    return (
        <>
            {event_pricing.length === 0 && (
                <>
                    <div className="d-flex justify-content-center text-14-400 ">
                        No Data Found
                    </div>
                </>
            )}


            {event_pricing?.length > 0 && showEventPricing && (
                <>
                    <div>
                        <div className="text-16-500 color-title-navy font-poppins mb-3">
                            Event Pricing
                        </div>
                        <div className="text-14-500">
                            Choose Registration Categories* :
                        </div>
                        <div className="cmt-16 d-flex gap-4 flex-wrap">
                            {event_pricing?.map((item) => (
                                <div key={item.id} className="d-flex gap-1 align-items-center">
                                    <CheckBox
                                        type="ACTIVE"
                                        isChecked={selectedIds?.includes(item.id)}
                                        onClick={() => handleCheckboxChange(item.id)}
                                    />
                                    {item.category}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="cmt-20 cmb-26">
                        <Label className='text-14-500' label="Event Type*  :" />
                        <div className="d-flex gap-3 cmt-16">
                            {event_mode.split(",")?.map((type) => (
                                <RadioInput
                                    key={type}
                                    label={type}
                                    value={type}
                                    onChange={handleEventTypeChange}
                                    checked={eventType === type}
                                />
                            ))}
                        </div>
                    </div>

                    {selectedIds.length > 0 && eventType &&
                        <div className="table-responsive  br-10">
                            <BootstrapTable bordered >
                                <thead className="table-header-container">
                                    <tr className="table-header-row-container">
                                        {findCategory.map((elem, index) => {

                                            const isVisible = elem?.is_checked || user_type === '0';
                                            return isVisible ? (
                                                <th key={index} className="header-cell" colSpan={index === 0 ? 2 : 1}>
                                                    {elem.category}
                                                </th>
                                            ) : null;
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {event_pricing
                                        .filter((item) => selectedIds.includes(item.id))
                                        .map((item, index) => (
                                            <React.Fragment key={item.id}>
                                                {/* Full-width category row */}
                                                <tr>
                                                    <td colSpan={findCategory.length + 1} className="text-14-500 text-center bg-f5f5ff py-3"
                                                    >
                                                        {item.category}
                                                    </td>
                                                </tr>

                                                {/* Price rows */}
                                                {["oral", "poster", "onSpot"].map((priceType) => (
                                                    <tr key={priceType}>
                                                        <td >{`${priceLabels[priceType]} :`}</td>

                                                        {findCategory?.map((cat) => {

                                                            // Determine whether to use physical or virtual based on eventType
                                                            const pricesArray = eventType === "Virtual" ? item?.virtual : item?.physical;

                                                            const pElem = pricesArray?.find((p) => p?.category === cat?.category);
                                                            const id = item.id;

                                                            // Get the correct value
                                                            let value = 0;
                                                            if (pElem) {
                                                                if (priceType.includes("oral")) value = ['0', '1', '6'].includes(user_type) ? pElem.oral : convertPrice(pElem.oral);
                                                                else if (priceType.includes("poster")) value = ['0', '1', '6'].includes(user_type) ? pElem.poster : convertPrice(pElem.poster);
                                                                else if (priceType.includes("onSpot")) value = ['0', '1', '6'].includes(user_type) ? pElem.onSpot : convertPrice(pElem.onSpot);
                                                            }

                                                            return (
                                                                <td key={cat.category}>
                                                                    {pElem && (
                                                                        <div>
                                                                            {isEdit ? (
                                                                                <RadioInput
                                                                                    id={`event_pricing-${id}-${eventType.toLowerCase()}-${pElem.id}-${priceType}`}
                                                                                    label={`${isNational ? '₹' : '$'}${value}`}
                                                                                    className="pe-4"
                                                                                    value="1"
                                                                                    checked={priceArray.includes(
                                                                                        `event_pricing-${id}-${eventType.toLowerCase()}-${pElem.id}-${priceType}`
                                                                                    )}
                                                                                    onChange={handelClick}
                                                                                />
                                                                            ) : ['0', '1', '6'].includes(user_type) ? (
                                                                                `${pricing_currency === 'INR' ? '₹' : '$'}${value}`
                                                                            ) : (
                                                                                `${isNational ? '₹' : '$'}${value}`
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            );
                                                        })}
                                                    </tr>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                </tbody>
                            </BootstrapTable>
                        </div>}
                </>
            )}


        </>
    )
}

export default EventPricing


// Old Flow 
// {event_pricing.length > 0 && showEventPricing && (
//                 <>
//                     <div className="text-16-500 color-title-navy font-poppins mb-3">
//                         Event Pricing
//                     </div>
//                     <BootstrapTable bordered className="">
//                         <thead className="table-header-container">
//                             <tr className="table-header-row-container">
//                                 <th className="header-cell" rowSpan={2}>
//                                     Registration Categories
//                                 </th>
//                                 <th className="header-cell" rowSpan={2}>
//                                     Event Type
//                                 </th>
//                                 {findCategory.map((elem, index) => {
//                                     return (
//                                         <th
//                                             className={`header-cell ${elem?.is_checked || user_type === '0' ? '' : 'd-none'
//                                                 }`}
//                                             key={index}
//                                             colSpan={3}
//                                         >
//                                             {elem.category}
//                                         </th>
//                                     );
//                                 })}
//                             </tr>
//                             <tr className="table-header-row-container">
//                                 {findCategory.map((elem, index) => {
//                                     return (
//                                         <React.Fragment key={index}>
//                                             <th
//                                                 className={`header-cell ${elem?.is_checked || user_type === '0' ? '' : 'd-none'
//                                                     }`}
//                                             >
//                                                 Early Bird Price
//                                             </th>
//                                             <th
//                                                 className={`header-cell ${elem?.is_checked || user_type === '0' ? '' : 'd-none'
//                                                     }`}
//                                             >
//                                                 Final Price
//                                             </th>
//                                             <th
//                                                 className={`header-cell ${elem?.is_checked || user_type === '0' ? '' : 'd-none'
//                                                     }`}
//                                             >
//                                                 On Spot Price
//                                             </th>
//                                         </React.Fragment>
//                                     );
//                                 })}
//                             </tr>
//                         </thead>
//                         <tbody className="table-body-container">
//                             {event_pricing.map((elem, index) => {
//                                 const { id, physical, virtual } = elem;
//                                 return (
//                                     <React.Fragment key={index}>
//                                         <tr className="table-body-row-container">
//                                             <td
//                                                 className="text-16-400 color-black-olive row-cell ps-2 pe-2 text-start"
//                                                 // rowSpan={event_mode === "Physical" ? 1 : 2}
//                                                 rowSpan={
//                                                     ['Physical', 'Virtual'].includes(event_mode) ? 1 : 2
//                                                 }
//                                             >
//                                                 {elem.category}
//                                             </td>
//                                             {['Hybrid', 'Physical']?.some((mode) =>
//                                                 event_mode?.split(',')?.includes(mode)
//                                             ) && (
//                                                     <td className="text-16-500 color-black-olive row-cell ps-5 pe-5 text-start">
//                                                         Physical
//                                                     </td>
//                                                 )}
//                                             {['Hybrid', 'Physical']?.some((mode) =>
//                                                 event_mode?.split(',')?.includes(mode)
//                                             ) &&
//                                                 physical?.map((pElem, pIndex) => {
//                                                     const isShow =
//                                                         findCategory.find((o) => o.id === pElem.id)
//                                                             ?.is_checked || user_type === '0';

//                                                     const convertPrice = (price) => {
//                                                         let convertedPrice = parseFloat(price);
//                                                         if (isNaN(convertedPrice)) return 0;
//                                                         if (pricing_currency === 'USD' && isNational) {
//                                                             convertedPrice = convertedPrice / inrPrice;
//                                                         } else if (
//                                                             pricing_currency === 'INR' &&
//                                                             !isNational
//                                                         ) {
//                                                             convertedPrice = convertedPrice * inrPrice;
//                                                         }
//                                                         return Number(convertedPrice.toFixed(2));
//                                                     };

//                                                     const newOralPrice = convertPrice(pElem.oral);
//                                                     const newPosterPrice = convertPrice(pElem.poster);
//                                                     const newonSpotPrice = convertPrice(pElem.onSpot);



//                                                     return (
//                                                         <React.Fragment key={pIndex}>
//                                                             <td
//                                                                 className={`row-cell ps-3 pe-2 text-start ${isShow ? '' : 'd-none'
//                                                                     }`}
//                                                             >
//                                                                 <div>
//                                                                     {isEdit ? (
//                                                                         <RadioInput
//                                                                             id={`event_pricing-${id}-physical-${pElem.id}-oral`}
//                                                                             label={`${isNational ? '₹' : '$'
//                                                                                 }${newOralPrice}`}
//                                                                             className="pe-4"
//                                                                             value="1"
//                                                                             checked={priceArray.includes(
//                                                                                 `event_pricing-${id}-physical-${pElem.id}-oral`
//                                                                             )}
//                                                                             onChange={handelClick}
//                                                                         />
//                                                                     ) : ['0', '1', '6'].includes(user_type) ? (
//                                                                         `${pricing_currency === 'INR' ? '₹' : '$'}${pElem.oral
//                                                                         }`
//                                                                     ) : (
//                                                                         `${isNational ? '₹' : '$'}${newOralPrice}`
//                                                                     )}
//                                                                 </div>
//                                                             </td>
//                                                             <td
//                                                                 className={`row-cell ps-3 pe-2 text-start ${isShow ? '' : 'd-none'
//                                                                     }`}
//                                                             >
//                                                                 <div>
//                                                                     {isEdit ? (
//                                                                         <RadioInput
//                                                                             id={`event_pricing-${id}-physical-${pElem.id}-poster`}
//                                                                             label={`${isNational ? '₹' : '$'
//                                                                                 }${newPosterPrice}`}
//                                                                             className="pe-4"
//                                                                             value="1"
//                                                                             checked={priceArray.includes(
//                                                                                 `event_pricing-${id}-physical-${pElem.id}-poster`
//                                                                             )}
//                                                                             onChange={handelClick}
//                                                                         />
//                                                                     ) : ['0', '1', '6'].includes(user_type) ? (
//                                                                         `${pricing_currency === 'INR' ? '₹' : '$'}${pElem.poster
//                                                                         }`
//                                                                     ) : (
//                                                                         `${isNational ? '₹' : '$'}${newPosterPrice}`
//                                                                     )}
//                                                                 </div>
//                                                             </td>
//                                                             <td
//                                                                 className={`row-cell ps-3 pe-2 text-start ${isShow ? '' : 'd-none'
//                                                                     }`}
//                                                             >
//                                                                 <div>
//                                                                     {isEdit ? (
//                                                                         <RadioInput
//                                                                             id={`event_pricing-${id}-physical-${pElem.id}-onSpot`}
//                                                                             label={`${isNational ? '₹' : '$'
//                                                                                 }${newonSpotPrice}`}
//                                                                             className="pe-4"
//                                                                             value="1"
//                                                                             checked={priceArray.includes(
//                                                                                 `event_pricing-${id}-physical-${pElem.id}-onSpot`
//                                                                             )}
//                                                                             onChange={handelClick}
//                                                                         />
//                                                                     ) : ['0', '1', '6'].includes(user_type) ? (
//                                                                         `${pricing_currency === 'INR' ? '₹' : '$'}${pElem.onSpot
//                                                                         }`
//                                                                     ) : (
//                                                                         `${isNational ? '₹' : '$'}${newonSpotPrice}`
//                                                                     )}
//                                                                 </div>
//                                                             </td>
//                                                         </React.Fragment>
//                                                     );
//                                                 })}
//                                         </tr>
//                                         {['Hybrid', 'Virtual']?.some((mode) =>
//                                             event_mode?.split(',')?.includes(mode)
//                                         ) && (
//                                                 <tr className="table-body-row-container">
//                                                     <td className="text-16-500 color-black-olive row-cell ps-5 pe-5 text-start">
//                                                         Virtual
//                                                     </td>
//                                                     {virtual?.map((vElem, pIndex) => {
//                                                         const isShow =
//                                                             findCategory.find((o) => o.id === vElem.id)
//                                                                 ?.is_checked || user_type === '0';

//                                                         const convertPrice = (price) => {
//                                                             let convertedPrice = parseFloat(price);
//                                                             if (isNaN(convertedPrice)) return 0;
//                                                             if (pricing_currency === 'USD' && isNational) {
//                                                                 convertedPrice = convertedPrice / inrPrice;
//                                                             } else if (
//                                                                 pricing_currency === 'INR' &&
//                                                                 !isNational
//                                                             ) {
//                                                                 convertedPrice = convertedPrice * inrPrice;
//                                                             }
//                                                             return Number(convertedPrice.toFixed(2));
//                                                         };

//                                                         const newOralPrice = convertPrice(vElem.oral);
//                                                         const newPosterPrice = convertPrice(vElem.poster);
//                                                         const newonSpotPrice = convertPrice(vElem.onSpot);

//                                                         return (
//                                                             <React.Fragment key={pIndex}>
//                                                                 <td
//                                                                     className={`row-cell ps-3 pe-2 text-start ${isShow ? '' : 'd-none'
//                                                                         }`}
//                                                                 >
//                                                                     <div>
//                                                                         {isEdit ? (
//                                                                             <RadioInput
//                                                                                 id={`event_pricing-${id}-virtual-${vElem.id}-oral`}
//                                                                                 label={`${isNational ? '₹' : '$'
//                                                                                     }${newOralPrice}`}
//                                                                                 className="pe-4"
//                                                                                 value="1"
//                                                                                 checked={priceArray.includes(
//                                                                                     `event_pricing-${id}-virtual-${vElem.id}-oral`
//                                                                                 )}
//                                                                                 onChange={handelClick}
//                                                                             />
//                                                                         ) : ['0', '1', '6'].includes(user_type) ? (
//                                                                             `${pricing_currency === 'INR' ? '₹' : '$'}${vElem.oral
//                                                                             }`
//                                                                         ) : (
//                                                                             `${isNational ? '₹' : '$'}${newOralPrice}`
//                                                                         )}
//                                                                     </div>
//                                                                 </td>
//                                                                 <td
//                                                                     className={`row-cell ps-3 pe-2 text-start ${isShow ? '' : 'd-none'
//                                                                         }`}
//                                                                 >
//                                                                     <div>
//                                                                         {isEdit ? (
//                                                                             <RadioInput
//                                                                                 id={`event_pricing-${id}-virtual-${vElem.id}-poster`}
//                                                                                 label={`${isNational ? '₹' : '$'
//                                                                                     }${newPosterPrice}`}
//                                                                                 className="pe-4"
//                                                                                 value="1"
//                                                                                 checked={priceArray.includes(
//                                                                                     `event_pricing-${id}-virtual-${vElem.id}-poster`
//                                                                                 )}
//                                                                                 onChange={handelClick}
//                                                                             />
//                                                                         ) : ['0', '1', '6'].includes(user_type) ? (
//                                                                             `${pricing_currency === 'INR' ? '₹' : '$'}${vElem.poster
//                                                                             }`
//                                                                         ) : (
//                                                                             `${isNational ? '₹' : '$'}${newPosterPrice}`
//                                                                         )}
//                                                                     </div>
//                                                                 </td>
//                                                                 <td
//                                                                     className={`row-cell ps-3 pe-2 text-start ${isShow ? '' : 'd-none'
//                                                                         }`}
//                                                                 >
//                                                                     <div>
//                                                                         {isEdit ? (
//                                                                             <RadioInput
//                                                                                 id={`event_pricing-${id}-virtual-${vElem.id}-onSpot`}
//                                                                                 label={`${isNational ? '₹' : '$'
//                                                                                     }${newonSpotPrice}`}
//                                                                                 className="pe-4"
//                                                                                 value="1"
//                                                                                 checked={priceArray.includes(
//                                                                                     `event_pricing-${id}-virtual-${vElem.id}-onSpot`
//                                                                                 )}
//                                                                                 onChange={handelClick}
//                                                                             />
//                                                                         ) : ['0', '1', '6'].includes(user_type) ? (
//                                                                             `${pricing_currency === 'INR' ? '₹' : '$'}${vElem.onSpot
//                                                                             }`
//                                                                         ) : (
//                                                                             `${isNational ? '₹' : '$'}${newonSpotPrice}`
//                                                                         )}
//                                                                     </div>
//                                                                 </td>
//                                                             </React.Fragment>
//                                                         );
//                                                     })}
//                                                 </tr>
//                                             )}
//                                     </React.Fragment>
//                                 );
//                             })}
//                         </tbody>
//                     </BootstrapTable>
//                 </>
//             )}